import type { TypedResponse } from '@remix-run/node';
import { useFetcher } from '@remix-run/react';

type ExcludeErrorResponse<T> = T extends TypedResponse<{ $$error: unknown }> ? never : T;
type UnwrapPromise<T> = T extends Promise<infer U> ? U : T;

export function useComponentFetcher<T extends (args: unknown) => Promise<unknown>>() {
  type Unwrapped = UnwrapPromise<ReturnType<T>>;
  type Excluded = ExcludeErrorResponse<Unwrapped>;
  type Fetcher = (args: unknown) => Promise<Excluded>;

  const fetcher = useFetcher<Fetcher>();
  handleComponentError(fetcher.data);

  return fetcher;
}

function handleComponentError<T>(fetcherData: T) {
  if (fetcherData && typeof fetcherData === 'object' && '$$error' in fetcherData) {
    throw fetcherData?.$$error;
  }
}
